import { convertFromRaw, convertToRaw, EditorState } from "draft-js"
import draftToHtml from "draftjs-to-html"
import React from "react"
import { Editor } from "react-draft-wysiwyg"
import { connect } from "react-redux"
import { bindActionCreators } from "redux"
import Actions from "../../actions"
import axios from "../../funcs/axios"
import "./react-draft-wysiwyg.css"
import "./styles.scss"

function mapStateToProps(state) {
    return {
        widgets: state.widgets,
        widget_selected: state.widget_selected,
        layout_button: state.layout_button,
        layout_mail: state.layout_mail,
        pages: state.pages,
        layout_reminder_mail: state.layout_reminder_mail,
    }
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Actions, dispatch),
    }
}

class EditorConvertToHTML extends React.Component<Props, State> {
    constructor(props) {
        super(props)
        this.loadShopName()
        const contentState = props.checkBiS
            ? convertFromRaw(props.layout_mail.textEditor)
            : convertFromRaw(props.layout_reminder_mail.textEditor)
        const editorState = EditorState.createWithContent(contentState)

        this.state = {
            contentState,
            shopName: "",
            editorState,
        }
    }

    onContentStateChange = (contentState) => {
        this.setState({
            contentState,
        })
    }

    loadShopName() {
        axios.get(`${window.SHOPIFY_APP_HOST}/admin/get-name-store`).then((response) => {
            this.setState({ shopName: response.data.shop.name})
        })
    }

    onEditorStateChange = (editorState) => {
        this.setState({
            editorState,
        })
        this.props.checkBiS ? this.handleChangeEmail() : this.handleChangeReminderEmail()
    }

    handleChangeEmail = () => {
        const { editorState, contentState } = this.state
        const { actions, layout_mail } = this.props
        let content = draftToHtml(convertToRaw(editorState.getCurrentContent()))
        let newLayout = Object.assign({}, layout_mail)
        newLayout.text = content
        newLayout.textEditor = contentState
        actions.changeLayoutMailAction(newLayout)
    }

    handleChangeReminderEmail = () => {
        const { editorState, contentState } = this.state
        const { actions, layout_reminder_mail } = this.props
        let content = draftToHtml(convertToRaw(editorState.getCurrentContent()))
        let newLayout = Object.assign({}, layout_reminder_mail)
        newLayout.text = content
        newLayout.textEditor = contentState
        actions.changeLayoutReminderMailAction(newLayout)
    }

    render() {
        console.log("checkBiS", this.props.checkBiS)
        const { editorState, shopName } = this.state
        const { layout_mail } = this.props
        const layout_button = layout_mail.button
        console.log('layout_mail', layout_mail)
        return (
            <div>
                <div className="form-mail">
                    <h1 style={{ fontSize: "25px" }}>{shopName}</h1>
                    <hr />
                    <strong>
                        <Editor
                            editorState={editorState}
                            wrapperClassName="demo-wrapper"
                            editorClassName="demo-editor"
                            onContentStateChange={this.onContentStateChange}
                            onEditorStateChange={this.onEditorStateChange}
                        />
                    </strong>
                    {this.props.checkBiS && (
                        <div style={{ display: "flex" }}>
                            <div style={{ width: "300px" }}>
                                <img
                                    className="imgProduct"
                                    src="https://cdn.shopify.com/s/images/themes/product-1.png"
                                />
                            </div>
                            <div style={{ margin: "auto" }}>
                                <p>ProductName</p>
                                <p>Variants</p>
                                <p>Price</p>
                                <a
                                    style={{
                                        borderRadius: layout_button.borderRadius + "px",
                                        fontSize: layout_button.fontSize + "px",
                                        color: layout_button.color,
                                        backgroundColor: layout_button.backgroundColor,
                                        padding: layout_button.padding + "px",
                                    }}
                                    className="buyBtn"
                                    title="Buy Now"
                                    href="{{PageURL}}"
                                    target="_blank"
                                >
                                    {layout_button.text}
                                </a>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        )
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(EditorConvertToHTML)
